import { boolean, z } from "zod";

export enum ConsultingSlot {
  Day = "Day",
  Evening = "Evening",
  Other = "Other",
}
export interface CategoryType {
  id?: string | undefined;
  name: string;
}
export interface GenericNamesType {
  id?: string | undefined;
  name: string;
}
export interface FrequencyType {
  id?: string | undefined;
  name: string;
}
export interface LengthType {
  id?: string | undefined;
  name: string;
}
export interface BrandDrugNameType {
  id?: string | undefined;
  name: string;
}
export interface BrandDrugTypeAdditionalInfo {
  id?: string | undefined;
  name: string;
  contents: string;
  formulation: string;
}
export interface FrequencyTypeAdditionalInfo {
  id?: string | undefined;
  name: string;
  description: string;
  translation: string;
}
export interface LengthTypeAdditionalInfo {
  id?: string | undefined;
  name: string;
  description: string;
}
export function isGenericDrugType(obj: any): boolean {
  return "id" in obj && "name" in obj;
}
export function isBrandDrugType(obj: any): boolean {
  if ("id" in obj && "name" in obj) {
    return true;
  }
  return false;
}
export const defaultPrescriptionValues = {
  category: { id: undefined, name: "" },
  generic_name: { id: undefined, name: "" },
  drug_name: {
    id: undefined,
    name: "",
  },
  prescription_frequency: {
    id: undefined,
    name: "",
    description: "",
    translation: "",
  },
  prescription_length: {
    id: undefined,
    name: "",
    description: "",
  },
  notes: "",
};
export const categorySchema = z.object({
  id: z.string().optional(),
  name: z.string(),
});
export const genericNameSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
});
export const drugNameSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  // contents: z.string().optional(),
  // formulation: z.string().optional(),
});

export const prescriptionFrequencySchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  description: z.string(),
  translation: z.string(),
});
export const prescriptionLengthSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  description: z.string(),
});
export const AppointmentPrescriptionSchema = z.object({
  category: categorySchema,
  generic_name: genericNameSchema,
  drug_name: drugNameSchema,
  prescription_frequency: prescriptionFrequencySchema,
  prescription_length: prescriptionLengthSchema,
  notes: z.string().optional(),
});
export type AppointmentPrescriptionSchemaType = z.infer<
  typeof AppointmentPrescriptionSchema
>;

export type PrescriptionType = {
  id: string;
  brandDrugName: string;
  brandDrugFormulationType: string;
  genericDrugName: string;
  appointmentId: string;
  prescriptionFrequencyName: string;
  prescriptionFrequencyDescription: string;
  prescriptionFrequencyTranslation: string;
  prescriptionLengthName: string;
  prescriptionLengthDescription: string;
  notes?: string;
};
